import React, { useState } from "react";
import { View, Text, StyleSheet, Image, Button, Alert, ActivityIndicator } from "react-native";
import MCALayout from "../../components/MCALayout";
import { useApiKeyStore } from "../../store/urlApiKeyStore";
import SuccessScreen from "../../components/SuccessScreen";
import { colorGreyOverlay } from "../../theme/colors";

type PaymentOptionProps = {
  navigation: any; // You can replace `any` with the actual navigation prop type
  route: any; // You can replace `any` with the actual route prop type
};

type PaymentDetails = {
  responseCode: number;
  data: {
      message: string;
      bank: string;
      account_number: string;
      amount: string;
      [key: string]: any;
  };
};

const PaymentOptionScreen : React.FC<PaymentOptionProps> = ({ navigation, route })=> {
  const [loading, setLoading] = useState<boolean>(false);
    const [buttonText, setButtonText] = useState<string>("Get Covered");
    const [paymentDetails, setPaymentDetails] = useState<PaymentDetails | null>(null);
    const [paymentResponse, setPaymentResponse] = useState<any>(null);
    const [paymentVerified, setPaymentVerified] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("Sending request...");
    const [paymentString, _] = useState<string>("bank transfer");
    const { apiKey, baseUrl } = useApiKeyStore();
    const { instanceId } = useApiKeyStore();

    let product = route.params.data.product;
    let formData = route.params.data.form;

    const failedDialog = (message: string) => {
        Alert.alert("Transaction Failed", message);
    };

    const initiatePurchase = () => {
        formData["product_id"] = product["id"];

        let payload = {
            // instance_id: global.instanceId,
            instance_id: instanceId,
            "payment_channel": {
                channel: paymentString
            },
            payload: formData
        };

        setLoading(true);

        let url = baseUrl + "/v1/sdk/initiate-purchase";

        const headers = { "Authorization": "Bearer " + apiKey, "Content-Type": "application/json" };

        let jsonBody = JSON.stringify(payload);

        fetch(url, { method: "POST", headers: headers, body: jsonBody })
            .then((response) => response.json())
            .then((json) => {
                if (json["responseCode"] == 1) {
                    setButtonText("I have sent the money");
                    setPaymentDetails(json);
                } else {
                    failedDialog(json["responseText"]);
                }
            }).catch((_) => { })
            .finally(() => setLoading(false));
    };
//error here _
    const verifyPayment = () => {
        setMessage("Verifying transaction...");
        setLoading(true);

        let url = baseUrl + "/v1/sdk/verify-transaction";

        let body = JSON.stringify({
            transaction_reference: paymentDetails!.data.reference
        });

        let headers = { "Authorization": "Bearer " + apiKey, "Content-Type": "application/json" };

        fetch(url, { method: "POST", headers: headers, body: body })
            .then((response) => response.json())
            .then((json) => {
                if (json["responseCode"] == 1) {
                    setPaymentResponse(json["data"]);
                    setPaymentVerified(true);
                } else {
                    Alert.alert("Unable to Verify", json["responseText"]);
                }
            })
            .catch((error) => { console.log(error); })
            .finally(() => setLoading(false));
    };

    const navigateToNext = () => {
        navigation.navigate("ProductForm", { data: product, formData: formData, transactionRef: paymentResponse.reference });
    };

    var hasSubmitted = paymentDetails && paymentDetails.responseCode == 1;

    const renderLayout = () => {
        if (paymentDetails && paymentDetails.responseCode == 1) {
            let bankDetails = paymentDetails.data;
            return (
                <View style={{ flex: 1, marginVertical: 8, backgroundColor: "#F9FAFB" }}>
                    <View style={{ flex: 5, alignItems: "center", justifyContent: "center" }}>
                        <Text style={{ fontFamily: "Raleway_400Regular", marginVertical: 12, color: "green" }}>{bankDetails.message}</Text>
                        <View
                            style={{
                                width: "80%",
                                marginVertical: 12,
                                borderBottomColor: '#D0D5DD',
                                borderBottomWidth: StyleSheet.hairlineWidth,
                            }}
                        />
                        <Text style={{ fontFamily: "Raleway_700Bold", textAlign: "center", fontSize: 25, fontWeight: "600", marginVertical: 12 }}>{bankDetails.bank + "\n" + bankDetails.account_number}</Text>
                        <View
                            style={{
                                width: "80%",
                                marginVertical: 12,
                                borderBottomColor: '#D0D5DD',
                                borderBottomWidth: StyleSheet.hairlineWidth,
                            }}
                        />
                    </View>
                    <View style={{ flex: 3 }}></View>
                </View>
            );
        }

        return (
            <View style={{ flex: 1 }}>
                <Text style={{ marginTop: 18, fontSize: 18, fontFamily: "Raleway_700Bold" }}>Select Payment Method</Text>
                <Text style={{ color: "#667085", marginTop: 5, marginBottom: 15, fontSize: 14, fontFamily: "Raleway_400Regular" }} >Choose an option to proceed</Text>

                <PaymentOptionCard imagePath={require("../../assets/transfer.png")} selected={paymentString == "bank transfer"} title="Transfer" sub="Send to bank account" />
                <View style={{ opacity: 0.2 }}>
                    <PaymentOptionCard imagePath={require("../../assets/ussd.png")} selected={paymentString == "ussd"} title="USSD" sub="Select any bank to generate USSD" />
                </View>
            </View>
        );
    };

    const handleButtonBehavior = () => {
        if (!hasSubmitted) {
            initiatePurchase();
        } else {
            verifyPayment();
        }
    };
    if (paymentVerified) {
      return (
          <SuccessScreen message={"Payment Verified,\nplease fill out the remaining fields"} onDonePressed={navigateToNext} />
      );
  }
    return (
      <View style={{ flex: 1 }}>
          <MCALayout>
              <View style={{ flex: 1, flexDirection: "column" }}>
                  <View style={{ flex: 1 }}>
                      <View style={styles.bio}>
                          <Text style={{ fontSize: 16, fontFamily: "Raleway_500Medium", }}>{hasSubmitted ? formData.email : product.name}</Text>
                          <Text style={{ fontFamily: "Raleway_400Regular", color: "#98A2B3" }}>{hasSubmitted ? "N" + paymentDetails?.data.amount : formData.email}</Text>
                      </View>
                      {renderLayout()}
                  </View>
                  <Button title={buttonText} onPress={handleButtonBehavior} color="#3BAA90" />
              </View>
          </MCALayout>
  
          {loading &&
              <View style={{ zIndex: 2, flex: 1, height: "100%", width: "100%", marginTop: "6%", position: "absolute", justifyContent: "center", alignItems: "center", backgroundColor: colorGreyOverlay }}>
                  <ActivityIndicator style={{ margin: 12, borderColor: "#3BAA90" }} animating={true} />
                  <Text style={{ fontFamily: "Raleway_500Medium", margin: 12, fontSize: 16, color: "white" }}>{message}</Text>
              </View>
          }
      </View>
  );
  
}



const styles = StyleSheet.create({
  bio: {
      padding: 8,
      marginVertical: 8,
      alignItems: "flex-end",
      backgroundColor: "#F6FEF9",
      borderRadius: 5,
  }
});

export default PaymentOptionScreen

export function PaymentOptionCard(props: { imagePath: any; selected: boolean; title: string; sub: string; }) {
  const style = StyleSheet.create({
      card: {
          marginVertical: 8,
          flexDirection: "row",
          paddingVertical: 12,
          borderWidth: 1,
          paddingHorizontal: 8,
          borderColor: "#667085",
          borderRadius: 5
      },
      cardSelected: {
          marginVertical: 8,
          flexDirection: "row",
          paddingVertical: 12,
          borderWidth: 1,
          paddingHorizontal: 8,
          borderColor: "#3BAA90",
          borderRadius: 5
      }
  });
  const selected = props.selected;
  return (
      <View style={selected ? style.cardSelected : style.card}>
          <Image source={props.imagePath} />
          <View style={{ marginHorizontal: 12 }}>
              <Text style={{ fontWeight: "600", fontFamily: "Raleway_500Medium", fontSize: 15 }}>{props.title}</Text>
              <Text style={{ marginTop: 5, fontSize: 12, fontFamily: "Raleway_400Regular" }}>{props.sub}</Text>
          </View>
      </View>
  );
}